import { CollapseOutlined, ExpandOutlined } from "@aircall/icons";

const collapse = {
  icon: CollapseOutlined,
  tooltip: "reduce",
};

const expand = {
  icon: ExpandOutlined,
  tooltip: "expand",
};

export const getProps = (isExpanded: boolean) =>
  isExpanded ? collapse : expand;
